import React, { useEffect, useState } from "react";
import ThemeTitle from "../../components/shared/themeTitle";
// import { articles } from "../../db/blog";
import { toTop, truncate } from "../../services/commonFunctions";

/**
 * BlogPage Component
 */
const BlogPage = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    toTop();
  }, []);

  useEffect(() => {
    const url = new URL("https://dev.to/api/articles");
    const params = { username: "youssefzidan" };

    Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));

    fetch(url)
      .then((res) => res.json())
      .then((res) => setArticles(res));
  }, []);

  const renderArticles = () =>
    articles.map((article) => {
      // render all article except article "my first react app"
      if (article.id !== 497349) {
        return (
          <div className="col-md-4 mb-5" key={article.title}>
            <a href={article.url} target="blank">
              <div className="card bg-dark-gray">
                {/* Image */}
                <img
                  src={article.cover_image}
                  className="card-img-top img-fluid"
                  alt={article.title}
                />
                <div className="card-body">
                  {/* Title */}
                  <h4 className="card-text text-white text-left font-weight-bold mb-4">
                    {article.title}
                  </h4>
                  {/* Description */}
                  <p className="card-text text-light-gray">{truncate(article.description, 80)}</p>
                </div>
              </div>
            </a>
          </div>
        );
      }
      return null;
    });
  return (
    <div id="blog" className="container mt-4">
      <ThemeTitle whiteColor="MY" primaryColor="BLOG" />
      <div className="row">{renderArticles()}</div>
    </div>
  );
};

export default BlogPage;
